import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const ROUTE_MAP = [
  { match: "/admin/sectionalTest", redirect: "/admin/extensive/new-sectional-tests" },
  { match: "/admin/test",          redirect: "/admin/mock" },
  { match: "/admin/fulltest",      redirect: "/admin/mock" },
];

const useBackButtonGuard = (active = true) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const getRedirectPath = () => {
    const match = ROUTE_MAP.find((r) => pathname.startsWith(r.match));
    return match ? match.redirect : "/admin/mock";
  };

  useEffect(() => {
    if (!active) return;

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
      return "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    // --- Back button guard ---
    window.history.pushState(null, "", window.location.href);
    const handlePopState = () => {
      window.history.pushState(null, "", window.location.href);
      setShowConfirm(true);
    };
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [active]);

  const confirmLeave = () => {
    setShowConfirm(false);
    navigate(getRedirectPath(), { replace: true });
  };

  const cancelLeave = () => setShowConfirm(false);

  return { showConfirm, confirmLeave, cancelLeave };
};

export default useBackButtonGuard;
